import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

export default styled(Link)`
  color: #4b4b4b;
  text-decoration: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
`;
